import loadable from "@loadable/component";
import SubscriptionsPage from "./page";
import { PaymentSuccess } from "./subscribe/payment-success-page";
import { PaymentCancel } from "./subscribe/payment-success-cancel";
import ManageSubscriptionPage from "./manage-subscription/page";

const NewSubscription = loadable(() => import("./subscribe/page"));

export const routes = [
  {
    path: "",
    element: <SubscriptionsPage />,
  },
  {
    path: "subscribe",
    element: <NewSubscription />,
  },
  {
    path: "success",
    element: <PaymentSuccess />,
  },
  {
    path: "cancel",
    element: <PaymentCancel />,
  },
  {
    path: "manage-subscription",
    element: <ManageSubscriptionPage />,
    children: [],
  },
];
